// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CoverMyMedsPriorAuthorizationHubEnrollmentCaregiver } from './coverMyMedsPriorAuthorizationHubEnrollmentCaregiver';
import type { CoverMyMedsPriorAuthorizationHubEnrollmentPatient } from './coverMyMedsPriorAuthorizationHubEnrollmentPatient';
import type { CoverMyMedsPriorAuthorizationHubEnrollmentPrescriptionDefinition } from './coverMyMedsPriorAuthorizationHubEnrollmentPrescriptionDefinition';
import type { CoverMyMedsPriorAuthorizationHubEnrollmentProvider } from './coverMyMedsPriorAuthorizationHubEnrollmentProvider';
import type { Moment } from 'moment';
import type { RequestFile } from '@trialcard/shared';

export class CoverMyMedsPriorAuthorizationHubEnrollment {
    'key': string;
    'diagnosis'?: string;
    'otherDiagnosis'?: string;
    'patient': CoverMyMedsPriorAuthorizationHubEnrollmentPatient;
    'provider': CoverMyMedsPriorAuthorizationHubEnrollmentProvider;
    'preferredContact'?: string;
    'caregiver': CoverMyMedsPriorAuthorizationHubEnrollmentCaregiver;
    'preferredLang'?: Array<string>;
    'preferredLangOther'?: string;
    'voicemailPreference'?: Array<string>;
    'prescriptionInsuranceCarrier'?: string;
    'prescriptionCardholderBeneficiary'?: string;
    'prescriptionMemberId'?: string;
    'prescriptionBin'?: string;
    'prescriptionPcn'?: string;
    'prescriptionGroupId'?: string;
    'medicalInsuranceCarrier'?: string;
    'medicalInsuranceCarrierPhone'?: string;
    'medicalCardId'?: string;
    'medicalGroupId'?: string;
    'secondaryMedicalInsuranceCarrier'?: string;
    'secondaryMedicalCardId'?: string;
    'secondaryMedicalGroupId'?: string;
    'hasRequestedInjectionDemonstration': boolean;
    'patientSignatureDate': string;
    'providerSignatureDate': string;
    'isTcpaConsented': boolean;
    'isFcraConsented': boolean;
    'isBridgeProgramConsented': boolean;
    'isEnrollmentCopayConsented': boolean;
    'hasClinicalTrialParticipation': boolean;
    'hasPreviousAlternateTreatment': boolean;
    'hasContraindication': boolean;
    'isPrescriptionSentToSpecialtyPharmacy': boolean;
    'contraindicationValue'?: string;
    'hasFailedAlternative': boolean;
    'failedAlternativeList'?: Array<string>;
    'failedAlternativeListOther'?: string;
    'hcpPreferredSpecialtyPharmacy'?: string;
    'hasPatientRepresentative': boolean;
    'prescriptionInsurancePhone'?: string;
    'hcpHasPreferredSpecialtyPharmacy': boolean;
    'patientMarketingSignatureDate': string;
    'patientSignatureReceivedDate': string;
    'diagnosisDate': string;
    'priorTherapies'?: string;
    'drugAllergies'?: string;
    'noKnownDrugAllergies': boolean;
    'substitutionsAllowed': boolean;
    'samplePackProvidedDate': string;
    'prescriptionDefinitions': Array<CoverMyMedsPriorAuthorizationHubEnrollmentPrescriptionDefinition>;
    'pdf': string;

    static discriminator: string | undefined = undefined;

    static additionalProperties = false;

    static attributeTypeMap: Array<{ name: string; baseName: string; type: string }> = [
        {
            "name":     "key",
            "baseName": "key",
            "type":     "string"
        },
        {
            "name":     "diagnosis",
            "baseName": "diagnosis",
            "type":     "string"
        },
        {
            "name":     "otherDiagnosis",
            "baseName": "otherDiagnosis",
            "type":     "string"
        },
        {
            "name":     "patient",
            "baseName": "patient",
            "type":     "CoverMyMedsPriorAuthorizationHubEnrollmentPatient"
        },
        {
            "name":     "provider",
            "baseName": "provider",
            "type":     "CoverMyMedsPriorAuthorizationHubEnrollmentProvider"
        },
        {
            "name":     "preferredContact",
            "baseName": "preferredContact",
            "type":     "string"
        },
        {
            "name":     "caregiver",
            "baseName": "caregiver",
            "type":     "CoverMyMedsPriorAuthorizationHubEnrollmentCaregiver"
        },
        {
            "name":     "preferredLang",
            "baseName": "preferredLang",
            "type":     ""
        },
        {
            "name":     "preferredLangOther",
            "baseName": "preferredLangOther",
            "type":     "string"
        },
        {
            "name":     "voicemailPreference",
            "baseName": "voicemailPreference",
            "type":     ""
        },
        {
            "name":     "prescriptionInsuranceCarrier",
            "baseName": "prescriptionInsuranceCarrier",
            "type":     "string"
        },
        {
            "name":     "prescriptionCardholderBeneficiary",
            "baseName": "prescriptionCardholderBeneficiary",
            "type":     "string"
        },
        {
            "name":     "prescriptionMemberId",
            "baseName": "prescriptionMemberId",
            "type":     "string"
        },
        {
            "name":     "prescriptionBin",
            "baseName": "prescriptionBin",
            "type":     "string"
        },
        {
            "name":     "prescriptionPcn",
            "baseName": "prescriptionPcn",
            "type":     "string"
        },
        {
            "name":     "prescriptionGroupId",
            "baseName": "prescriptionGroupId",
            "type":     "string"
        },
        {
            "name":     "medicalInsuranceCarrier",
            "baseName": "medicalInsuranceCarrier",
            "type":     "string"
        },
        {
            "name":     "medicalInsuranceCarrierPhone",
            "baseName": "medicalInsuranceCarrierPhone",
            "type":     "string"
        },
        {
            "name":     "medicalCardId",
            "baseName": "medicalCardId",
            "type":     "string"
        },
        {
            "name":     "medicalGroupId",
            "baseName": "medicalGroupId",
            "type":     "string"
        },
        {
            "name":     "secondaryMedicalInsuranceCarrier",
            "baseName": "secondaryMedicalInsuranceCarrier",
            "type":     "string"
        },
        {
            "name":     "secondaryMedicalCardId",
            "baseName": "secondaryMedicalCardId",
            "type":     "string"
        },
        {
            "name":     "secondaryMedicalGroupId",
            "baseName": "secondaryMedicalGroupId",
            "type":     "string"
        },
        {
            "name":     "hasRequestedInjectionDemonstration",
            "baseName": "hasRequestedInjectionDemonstration",
            "type":     "boolean"
        },
        {
            "name":     "patientSignatureDate",
            "baseName": "patientSignatureDate",
            "type":     "string"
        },
        {
            "name":     "providerSignatureDate",
            "baseName": "providerSignatureDate",
            "type":     "string"
        },
        {
            "name":     "isTcpaConsented",
            "baseName": "isTcpaConsented",
            "type":     "boolean"
        },
        {
            "name":     "isFcraConsented",
            "baseName": "isFcraConsented",
            "type":     "boolean"
        },
        {
            "name":     "isBridgeProgramConsented",
            "baseName": "isBridgeProgramConsented",
            "type":     "boolean"
        },
        {
            "name":     "isEnrollmentCopayConsented",
            "baseName": "isEnrollmentCopayConsented",
            "type":     "boolean"
        },
        {
            "name":     "hasClinicalTrialParticipation",
            "baseName": "hasClinicalTrialParticipation",
            "type":     "boolean"
        },
        {
            "name":     "hasPreviousAlternateTreatment",
            "baseName": "hasPreviousAlternateTreatment",
            "type":     "boolean"
        },
        {
            "name":     "hasContraindication",
            "baseName": "hasContraindication",
            "type":     "boolean"
        },
        {
            "name":     "isPrescriptionSentToSpecialtyPharmacy",
            "baseName": "isPrescriptionSentToSpecialtyPharmacy",
            "type":     "boolean"
        },
        {
            "name":     "contraindicationValue",
            "baseName": "contraindicationValue",
            "type":     "string"
        },
        {
            "name":     "hasFailedAlternative",
            "baseName": "hasFailedAlternative",
            "type":     "boolean"
        },
        {
            "name":     "failedAlternativeList",
            "baseName": "failedAlternativeList",
            "type":     ""
        },
        {
            "name":     "failedAlternativeListOther",
            "baseName": "failedAlternativeListOther",
            "type":     "string"
        },
        {
            "name":     "hcpPreferredSpecialtyPharmacy",
            "baseName": "hcpPreferredSpecialtyPharmacy",
            "type":     "string"
        },
        {
            "name":     "hasPatientRepresentative",
            "baseName": "hasPatientRepresentative",
            "type":     "boolean"
        },
        {
            "name":     "prescriptionInsurancePhone",
            "baseName": "prescriptionInsurancePhone",
            "type":     "string"
        },
        {
            "name":     "hcpHasPreferredSpecialtyPharmacy",
            "baseName": "hcpHasPreferredSpecialtyPharmacy",
            "type":     "boolean"
        },
        {
            "name":     "patientMarketingSignatureDate",
            "baseName": "patientMarketingSignatureDate",
            "type":     "string"
        },
        {
            "name":     "patientSignatureReceivedDate",
            "baseName": "patientSignatureReceivedDate",
            "type":     "string"
        },
        {
            "name":     "diagnosisDate",
            "baseName": "diagnosisDate",
            "type":     "string"
        },
        {
            "name":     "priorTherapies",
            "baseName": "priorTherapies",
            "type":     "string"
        },
        {
            "name":     "drugAllergies",
            "baseName": "drugAllergies",
            "type":     "string"
        },
        {
            "name":     "noKnownDrugAllergies",
            "baseName": "noKnownDrugAllergies",
            "type":     "boolean"
        },
        {
            "name":     "substitutionsAllowed",
            "baseName": "substitutionsAllowed",
            "type":     "boolean"
        },
        {
            "name":     "samplePackProvidedDate",
            "baseName": "samplePackProvidedDate",
            "type":     "string"
        },
        {
            "name":     "prescriptionDefinitions",
            "baseName": "prescriptionDefinitions",
            "type":     ""
        },
        {
            "name":     "pdf",
            "baseName": "pdf",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return CoverMyMedsPriorAuthorizationHubEnrollment.attributeTypeMap;
    }
}
